export default "<div *ngIf=\"show\" [ngStyle]=\"{width: width, height: height}\">\n  <div [style.background]=\"color\"  class=\"ball\" ></div>\n</div>"